module.exports = __webpack_public_path__ + "main/assets/public/rrr-50/rrr.ad76db7dfbe13a0d.svg";